<template>
  <div
    class="sider"
    style="width: 100%; height: 100%; border-right: 1px solid #e8e8e8"
  >
    <div
      style="
        display: flex;
        flex-direction: column;
        padding: 5px;
        align-items: center;
        justify-content: center;
      "
    >
      <img src="/final.png" width="100%" height="auto" />
      <div style="height: 1vh" />
    </div>
    <a-menu
      mode="inline"
      :open-keys="openKeys"
      :defaultSelectedKeys="[$route.path]"
      style="width: 100%"
      :default-keys="['admin']"
      @openChange="onOpenChange"
    >
      <!-- <a-sub-menu key="buddy" >
        <span slot="title"><span>Buddy System</span></span>
        <a-menu-item key="/meeting">
          <router-link to="/meeting">My Meetings</router-link>
        </a-menu-item>
        <a-menu-item key="/meeting/calendar">
          <router-link to="/meeting/calendar">Calendar</router-link>
        </a-menu-item>
      </a-sub-menu>-->
      <a-sub-menu key="admin">
        <span slot="title">
          <span>Admin System</span>
        </span>
        <a-menu-item key="/admin/waitList">
          <router-link to="/admin/waitList">All Wait Volunteer</router-link>
        </a-menu-item>
        <a-menu-item key="/admin/elder">
          <router-link to="/admin/elder">All Elder</router-link>
        </a-menu-item>
        <a-menu-item key="/admin/volunteer">
          <router-link to="/admin/volunteer">All Volunteer</router-link>
        </a-menu-item>
        <!-- <a-menu-item key="/admin/meeting">
          <router-link to="/admin/meeting">All Meeting</router-link>
        </a-menu-item>
        <a-menu-item key="/admin/tasks">
          <router-link to="/admin/tasks">All Tasks</router-link>
        </a-menu-item>
        <a-menu-item key="/admin/requests">
          <router-link to="/admin/requests">All Requests</router-link>
        </a-menu-item> -->
        <a-menu-item key="/admin/feedback">
          <router-link to="/admin/feedback">All Feedbacks</router-link>
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
    <div class="quit" @click="confirmquit">
      <a-icon type="logout" />
      <span>Logout</span>
    </div>
  </div>
</template>
<style lang="less" scoped>
.sider {
  position: relative;
  .quit {
    position: absolute;
    bottom: 30px;
    left: 40%;
    cursor: pointer;
  }
}
@media screen and (max-width: 1300px) {
  .sider {
  }
}
</style>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      rootSubmenuKeys: ["buddy", "admin", "sub4"],
      openKeys: ["admin"],
    };
  },
  computed: {
    ...mapGetters(["isAdmin", "curuser"]),
  },
  methods: {
    ...mapActions({ quit: "user/logout" }),
    // logout() {

    // },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    confirmquit() {
      let that = this;
      this.$confirm({
        title: "Do you want to logout?",

        onOk() {
          that.quit();
          localStorage.clear();

          that.$router.replace("/");
        },
        onCancel() {},
      });
    },
  },
};
</script>
